const bedOptions = ['', 'studio', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
// eslint-disable-next-line max-len
const bathOptions = [
  '',
  '1',
  '1.5',
  '2',
  '2.5',
  '3',
  '3.5',
  '4',
  '4.5',
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10+',
];

const bedOptionsArray = [
  { label: 'studio', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
];

const bathOptionsArray = [
  { label: '1', value: 1 },
  { label: '1.5', value: 1.5 },
  { label: '2', value: 2 },
  { label: '2.5', value: 2.5 },
  { label: '3', value: 3 },
  { label: '3.5', value: 3.5 },
  { label: '4', value: 4 },
  { label: '4.5', value: 4.5 },
  { label: '5', value: 5 },
  { label: '5.5', value: 5.5 },
  { label: '6', value: 6 },
  { label: '6.5', value: 6.5 },
  { label: '7', value: 7 },
  { label: '7.5', value: 7.5 },
  { label: '8', value: 8 },
  { label: '8.5', value: 8.5 },
  { label: '9', value: 9 },
  { label: '9.5', value: 9.5 },
  { label: '10+', value: 10 },
];

const baseOptionsPersonCount = [
  { label: 'Select Option', value: '' },
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5+', value: '5+' },
];

const petsOptions = [
  { label: 'Select Option', value: '' },
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3+', value: '3+' },
];

const leaseDurationOptions = [
  { label: 'Select Option', value: '' },
  { label: '1 month', value: '1mo' },
  { label: '6 months', value: '6mo' },
  { label: '1 year', value: '1y' },
  { label: 'Rent to own', value: 'r2o' },
  { label: 'Sublet/temporary', value: 'sub' },
];

const roommatesOptionsArray = [...baseOptionsPersonCount];

export {
  bedOptions,
  bedOptionsArray,
  bathOptions,
  bathOptionsArray,
  petsOptions,
  roommatesOptionsArray,
  leaseDurationOptions,
};
